



















import { Vue, Prop, Component } from 'vue-property-decorator';

@Component
export default class PageHeadline extends Vue {
  @Prop({default: 'Page Headline', required: false}) private title!: string;
  @Prop({default: '', required: false}) private description!: string;
  @Prop({default: '', required: false}) private descriptionClass!: string;
  @Prop({default: true, required: false}) private center!: boolean;
  @Prop({default: false, required: false}) private white!: string;
}
